import { render, staticRenderFns } from "./AssignRoleModal.vue?vue&type=template&id=2c0a750d&scoped=true&"
import script from "./AssignRoleModal.vue?vue&type=script&lang=js&"
export * from "./AssignRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a750d",
  null
  
)

export default component.exports